import React from "react";
import { Box, TextField, Button, Paper, Typography, Grid } from "@mui/material";

interface ReportFiltersProps {
    filters: { from: string; to: string };
    setFilters: React.Dispatch<React.SetStateAction<{ from: string; to: string }>>;
}

const ReportFilters: React.FC<ReportFiltersProps> = ({ filters, setFilters }) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    return (
        <Paper elevation={1} sx={{ p: 3, mb: 3, borderRadius: 1 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Filter Report
            </Typography>

            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={4} md={3}>
                    <TextField
                        label="From Date"
                        name="from"
                        type="date"
                        fullWidth
                        value={filters.from || ""}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item xs={12} sm={4} md={3}>
                    <TextField
                        label="To Date"
                        name="to"
                        type="date"
                        fullWidth
                        value={filters.to || ""}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item xs={12} sm={4} md={3}>
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        sx={{
                            textTransform: "none",
                            color: "white",
                            borderImage: "linear-gradient(95.53deg, #4DD26B 0%, #08B1B6 99.12%)",
                            borderImageSlice: 1,
                            backgroundImage: "linear-gradient(95.53deg, #4DD26B 0%, #08B1B6 99.12%)",
                            "&:hover": {
                                backgroundImage: "linear-gradient(95.53deg, #4DD26B 0%, #08B1B6 99.12%)",
                                opacity: 0.9,
                            },
                        }}
                        onClick={() => setFilters({ ...filters })}
                    >
                        Apply Filters
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
};


export default ReportFilters;